var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 391 238",
    style: {
      enableBackground: "new 0 0 391 238"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.footer-logo-st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.footer-logo-st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.footer-logo-st2{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FEFEFE;}\n\t.footer-logo-st3{fill-rule:evenodd;clip-rule:evenodd;fill:#1B397B;}\n\t.footer-logo-st4{fill:#FFFFFF;}\n\t.footer-logo-st5{fill-rule:evenodd;clip-rule:evenodd;fill:#050101;}\n\t.footer-logo-st6{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.footer-logo-st7{mask:url(#mask-2_10_);fill-rule:evenodd;clip-rule:evenodd;fill:#050101;}\n\t.footer-logo-st8{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.footer-logo-st9{mask:url(#mask-2_9_);fill-rule:evenodd;clip-rule:evenodd;fill:#050101;}\n\t.footer-logo-st10{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.footer-logo-st11{mask:url(#mask-2_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#050101;}\n\t.footer-logo-st12{filter:url(#Adobe_OpacityMaskFilter_4_);}\n\t.footer-logo-st13{mask:url(#mask-2_7_);fill-rule:evenodd;clip-rule:evenodd;fill:#050101;}\n\t.footer-logo-st14{filter:url(#Adobe_OpacityMaskFilter_5_);}\n\t.footer-logo-st15{mask:url(#mask-2_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#050101;}\n\t.footer-logo-st16{fill-rule:evenodd;clip-rule:evenodd;fill:#E9A22F;}\n\t.footer-logo-st17{filter:url(#Adobe_OpacityMaskFilter_6_);}\n\t.footer-logo-st18{mask:url(#mask-4_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#E9A22F;}\n\t.footer-logo-st19{filter:url(#Adobe_OpacityMaskFilter_7_);}\n\t.footer-logo-st20{mask:url(#mask-6_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#1B397B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LG-Web"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LG-Web-top",
    transform: "translate(-524.000000, -4606.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer-logo",
    transform: "translate(524.000000, 4606.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 379,
    height: 248
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 379,
    height: 248,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1_1_",
    y: 0,
    className: "footer-logo-st1",
    width: 391,
    height: 238
  }))), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st2",
    d: "M109.4,98.9c4.6-33,20.4-58.8,48.4-76.4C177.3,10.2,199,5.1,221.9,7.6c26.6,2.9,49.1,14.3,66.7,34.6 c16,18.4,19,26.8,26.4,71c16.7,2,32.6,6.5,45.9,17.8c21.6,18.5,29.6,48.6,20.1,76.7c-8.7,25.7-33.9,45.9-61.3,46.5 c-41.3,0.9-82.6,0.5-123.9,0.5c-37.9,0-75.9,0.8-113.8-0.3C35,253,0.6,211,6.7,166.6c6.7-49.2,47.6-77.5,96.6-68.7 C105.1,98.2,106.8,98.4,109.4,98.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LG-Web_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LG-Web-top_1_",
    transform: "translate(-120.000000, -256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(120.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-top",
    transform: "translate(0.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4_1_",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_",
    className: "footer-logo-st3",
    d: "M72.3,74.5h244.6c5.8,0,10.5,5.4,10.5,12.1l0,0c0,6.7-4.7,12.1-10.5,12.1H72.3 c-5.8,0-10.5-5.4-10.5-12.1l0,0C61.8,80,66.5,74.5,72.3,74.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M119.8,85.3v-1.1h6.7v1.1c-0.7,0.8-1.4,1.4-2.3,2.1h4.6v1.1H124v1.8c0,0.6-0.1,1-0.3,1.2 c-0.2,0.1-0.7,0.2-1.4,0.2c-0.5,0-1.1,0-2,0l0-1.1c1,0,1.6,0.1,1.9,0.1c0.2,0,0.4,0,0.4-0.1c0,0,0.1-0.2,0.1-0.4v-1.6h-5.1 v-1.1h5.1v-1h0.8c0.5-0.4,0.9-0.7,1.3-1.1H119.8z M127,83.3h-7.8v2H118v-3h1.7c-0.2-0.4-0.4-0.7-0.6-1.1l1.2-0.5 c0.3,0.4,0.6,1,0.9,1.6h1.5c-0.3-0.5-0.5-0.9-0.7-1.2l1.1-0.5c0.3,0.5,0.6,1.1,0.9,1.7h1.3c0.3-0.5,0.6-1.1,0.9-1.6 l1.2,0.3c-0.2,0.5-0.5,0.9-0.7,1.3h1.7v3H127V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M137,80.5h1.3v1.4h3.1V83h-7.3v0.9h-1.2c0.1,0.2,0.2,0.4,0.4,0.8c0.2,0.4,0.3,0.7,0.4,0.9 c0.8-0.7,1.4-1.6,2-2.5l1,0.6c-0.5,1.1-1.4,2.1-2.5,3c0,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.1,0.3,0.1,0.3l-1,0.7 c0-0.1-0.1-0.4-0.3-0.9c-0.2-0.5-0.3-0.9-0.4-1.1v5.7h-1.2v-4.9c-0.3,0.8-0.6,1.7-1,2.4l-0.7-1.2c0.7-1.3,1.2-2.7,1.5-4.2 h-1.2v-1.1h1.5v-2h1.2v2h1v-0.9h3.2V80.5z M141.6,90.7l-0.4,1.1c-1.5-0.5-2.7-1.1-3.6-1.9c-0.9,0.8-2.2,1.4-3.8,1.9 l-0.5-1.1c1.5-0.5,2.6-1.1,3.4-1.7c-0.6-0.8-1.2-1.7-1.5-2.9l1.2-0.3c0.3,1,0.7,1.8,1.2,2.4c0.5-0.6,1-1.4,1.3-2.4l1.2,0.3 c-0.4,1.2-1,2.2-1.7,3C139.1,89.6,140.2,90.1,141.6,90.7z M138.3,83.9l0.9-0.8c1,0.9,1.8,1.8,2.4,2.7l-0.9,0.8 C140,85.6,139.2,84.7,138.3,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M152.2,89.8v-6.5h-7.7v8.4h-1.3v-9.5h3.6c0.2-0.5,0.5-1.1,0.7-1.7l1.3,0.2c-0.3,0.6-0.5,1.2-0.7,1.6 h5.4v7.6c0,0.8-0.1,1.3-0.3,1.5c-0.2,0.2-0.6,0.3-1.4,0.3c-0.5,0-1.1,0-2,0l-0.1-1.1c0.8,0,1.4,0.1,1.7,0.1 c0.3,0,0.5,0,0.6-0.1C152.2,90.3,152.2,90.1,152.2,89.8z M147,88.8v1h-1.2v-5.3h5.1v4.3H147z M147,87.8h2.6v-2.3H147V87.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M158,81.4c-0.4,1.5-0.6,3.1-0.6,4.9c0,1.7,0.2,3.4,0.6,4.9l-1.3,0.1c-0.4-1.6-0.6-3.2-0.6-5 s0.2-3.5,0.6-5L158,81.4z M159.4,83.5h3.9v-2.3h1.2v2.3h1.9v1.1h-1.9v1.7c0,1.2-0.1,2.1-0.3,2.7c-0.2,0.6-0.5,1.1-1,1.5 c-0.5,0.4-1.2,0.7-2.2,0.9l-0.4-1.1c0.4-0.1,0.7-0.2,1-0.3c0.2-0.1,0.5-0.2,0.7-0.4c0.2-0.1,0.4-0.3,0.5-0.5 c0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.3,0.1-0.6,0.2-0.9c0-0.3,0-0.8,0-1.3v-1.7h-3.9V83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M182.9,85.3v-1.1h6.7v1.1c-0.7,0.8-1.4,1.4-2.3,2.1h4.6v1.1H187v1.8c0,0.6-0.1,1-0.3,1.2 c-0.2,0.1-0.7,0.2-1.4,0.2c-0.5,0-1.1,0-2,0l0-1.1c1,0,1.6,0.1,1.9,0.1c0.2,0,0.4,0,0.4-0.1c0,0,0.1-0.2,0.1-0.4v-1.6h-5.1 v-1.1h5.1v-1h0.8c0.5-0.4,0.9-0.7,1.3-1.1H182.9z M190.1,83.3h-7.8v2H181v-3h1.7c-0.2-0.4-0.4-0.7-0.6-1.1l1.2-0.5 c0.3,0.4,0.6,1,0.9,1.6h1.5c-0.3-0.5-0.5-0.9-0.7-1.2l1.1-0.5c0.3,0.5,0.6,1.1,0.9,1.7h1.3c0.3-0.5,0.6-1.1,0.9-1.6 l1.2,0.3c-0.2,0.5-0.5,0.9-0.7,1.3h1.7v3h-1.2V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M193.3,84.6c1.3-0.4,2.4-0.8,3.4-1.2l0.3,1c-0.4,0.2-0.8,0.4-1.2,0.5c0.2,0,0.3,0,0.6,0 c0.2,0,0.3,0,0.4,0c0.2,0,0.3,0,0.3,0c0,0,0.1-0.1,0.1-0.2v-2.6h-2.4c0.6,0.3,1,0.6,1.4,0.9l-0.6,0.8 c-0.6-0.4-1.2-0.8-1.9-1.2l0.4-0.5h-0.6v-1h4.9v4c0,0.2,0,0.4-0.1,0.5l1.1,0.1c-0.1,0.4-0.2,0.6-0.3,0.8h4.1v5.2h-1.3v-0.5 h-6.1v0.5h-1.3v-5.2h3.3c0.1-0.4,0.2-0.6,0.2-0.6c-0.2,0-0.5,0.1-0.9,0.1c-0.2,0-0.8,0-1.7,0l0-0.8 c-0.5,0.2-1.1,0.4-1.7,0.6L193.3,84.6z M195.8,88.4h6.1v-0.9h-6.1V88.4z M201.9,90.2v-0.9h-6.1v0.9H201.9z M198.9,84.5 c1.3-0.4,2.4-0.8,3.4-1.2l0.3,1c-0.4,0.2-0.8,0.4-1.3,0.6c0.5,0,0.9,0,1.1,0c0.2,0,0.3,0,0.3,0c0,0,0.1-0.1,0.1-0.2v-2.6 h-2.3c0.6,0.3,1,0.6,1.4,0.9l-0.6,0.8c-0.5-0.4-1.2-0.8-1.9-1.2l0.4-0.5H199v-1h4.9v4c0,0.4-0.1,0.7-0.2,0.8 c-0.1,0.1-0.5,0.1-1.1,0.1c-0.2,0-0.8,0-1.7,0l0-0.9c-0.5,0.2-1.1,0.4-1.7,0.6L198.9,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M210,88c0,0.6,0.2,1,0.6,1.4c0.4,0.3,0.8,0.5,1.4,0.5c0.6,0,1.2-0.2,1.8-0.5l0.3,0.9 c-0.7,0.3-1.5,0.5-2.3,0.5c-0.9,0-1.7-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.4c0-1,0.3-1.8,0.8-2.4c0.5-0.6,1.3-0.9,2.2-0.9 c0.9,0,1.6,0.3,2.1,0.8c0.5,0.6,0.8,1.4,0.8,2.4c0,0.1,0,0.3,0,0.6H210z M210,87h3.4c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.3,0.5C210.2,86,210.1,86.4,210,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M221.2,85.3l1.2,0.4c-0.6,1.5-1.3,2.9-2,4.3l-1.2-0.5C220,88.2,220.6,86.8,221.2,85.3z M225.4,84.1 v5.5c0,0.7-0.1,1.2-0.3,1.4c-0.2,0.2-0.6,0.3-1.3,0.3c-0.6,0-1.2-0.1-2-0.2L222,90c0.6,0.1,1.1,0.1,1.6,0.1 c0.3,0,0.4,0,0.5-0.1c0-0.1,0.1-0.2,0.1-0.6v-5.3h-4.5V83h4.5v-2h1.3v2h2.2c-0.2-0.3-0.3-0.6-0.3-1c0-0.5,0.2-0.9,0.5-1.2 c0.3-0.3,0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.6 v0.5H225.4z M226.8,85.8l1.2-0.5c0.7,1.5,1.4,2.9,2,4.4l-1.2,0.5C228.1,88.6,227.5,87.2,226.8,85.8z M229.6,82.6 c0.2-0.2,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.3-0.2-0.6-0.2s-0.4,0.1-0.6,0.2c-0.2,0.2-0.2,0.3-0.2,0.6 c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.3,0.2,0.6,0.2S229.4,82.7,229.6,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M232.3,86.9v-1.3h10v1.3H232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M247.6,81l1.2,0.1c0,0.3-0.1,0.7-0.2,1.1h5.7v0.5c0,2.8-0.6,4.8-1.9,6.2c-1.3,1.3-3.4,2.1-6.2,2.4 l-0.2-1.2c1.4-0.1,2.6-0.4,3.5-0.8c0.9-0.4,1.7-0.9,2.2-1.6c-1.4-0.7-2.7-1.3-3.7-1.8l0.6-1.1c1.4,0.6,2.6,1.2,3.8,1.8 c0.4-0.8,0.6-1.9,0.6-3.2h-4.6c-0.5,1.4-1.3,2.6-2.4,3.7l-0.9-0.8c0.7-0.7,1.3-1.5,1.7-2.4C247.2,83,247.5,82,247.6,81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "footer-logo-st4",
    d: "M259.4,81.6h1.3V84c0,1.6-0.1,2.9-0.3,3.8c-0.2,0.9-0.5,1.6-0.9,2.1c-0.4,0.5-1,0.9-1.7,1.3l-0.7-1.1 c0.7-0.3,1.1-0.7,1.4-1.1c0.3-0.4,0.5-0.9,0.6-1.7c0.1-0.7,0.2-1.9,0.2-3.3V81.6z M262.6,81.6h1.3v8.2 c1.8-0.4,2.8-1.8,3.1-4.3l1.2,0.2c-0.2,1.8-0.7,3.1-1.6,4.1c-0.9,0.9-2.2,1.4-3.8,1.4h-0.2V81.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16_1_",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8_1_",
    className: "footer-logo-st5",
    points: "155.4,181 123.7,181 123.7,137.6 134.7,137.6 134.7,173.8 155.4,173.8 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11_1_"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 157.2,
    y: 154.8,
    width: 15.8,
    height: 9.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 157.2,
    y: 154.8,
    width: 15.8,
    height: 9.1,
    id: "mask-2_10_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_10_",
    className: "footer-logo-st1",
    points: "57.1,188.1 316.7,188.1 316.7,130.2 57.1,130.2  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10_1_",
    className: "footer-logo-st7",
    points: "157.2,163.8 173,163.8 173,154.8 157.2,154.8  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 180.1,
    y: 136.7,
    width: 42,
    height: 45.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 180.1,
    y: 136.7,
    width: 42,
    height: 45.1,
    id: "mask-2_9_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_9_",
    className: "footer-logo-st1",
    points: "57.1,188.1 316.7,188.1 316.7,130.2 57.1,130.2  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12_1_",
    className: "footer-logo-st9",
    d: "M222.1,175.1c-3.4,3.2-10.6,6.8-19.9,6.8c-15.6,0-22.2-9.1-22.2-22.9 c0-14.9,8.7-22.2,22.4-22.2c8,0,15.3,4.3,19.2,11.9l-11.4,1.8c-2-4.7-4-6.5-7.7-6.5c-5.4,0-11.2,4.3-11.2,15.4 c0,10.3,4.3,15.4,11.2,15.4c4.2,0,7.4-0.9,9-1.8v-7.5h-8v-7.2h18.6V175.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 227.7,
    y: 147.7,
    width: 30.3,
    height: 34
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 227.7,
    y: 147.7,
    width: 30.3,
    height: 34,
    id: "mask-2_8_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_8_",
    className: "footer-logo-st1",
    points: "57.1,188.1 316.7,188.1 316.7,130.2 57.1,130.2  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13_1_",
    className: "footer-logo-st11",
    d: "M246.5,165.7c-5.8,0.9-8.1,3.2-8.1,5.9c0,2.1,1.1,3.4,3.1,3.4c1.5,0,3.4-0.6,5-1.8 V165.7z M247.6,181c-0.3-0.4-0.5-1-0.6-1.6h-0.2c-1.5,1-4.2,2.3-8,2.3c-7.5,0-11.1-3.5-11.1-9.2c0-6.1,4.3-10.4,18.8-12.4 v-1c0-3.1-0.8-5.3-3.4-5.3c-2.1,0-3.1,2.2-3.6,4.1l-10.3-0.5c1.1-4.7,4.4-9.6,14.1-9.6c8.3,0,13.7,2.5,13.7,12.7v15.8 c0,2.4,0.2,3.9,1,4.4v0.4H247.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 262.4,
    y: 141.2,
    width: 19.7,
    height: 40.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 262.4,
    y: 141.2,
    width: 19.7,
    height: 40.5,
    id: "mask-2_7_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_7_",
    className: "footer-logo-st1",
    points: "57.1,188.1 316.7,188.1 316.7,130.2 57.1,130.2  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14_1_",
    className: "footer-logo-st13",
    d: "M265.3,141.2h10.5v7.2h4.3v6.6h-4.3v13.2c0,4.2,0.5,6.4,2.4,6.4c1.1,0,2-0.6,2.6-1.2 l1.4,6.8c-2,0.8-3.8,1.4-6.6,1.4c-6.7,0-10.2-3.3-10.2-11.3v-15.3h-2.8v-6.6h2.8V141.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 285.6,
    y: 147.7,
    width: 31.1,
    height: 34
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 285.6,
    y: 147.7,
    width: 31.1,
    height: 34,
    id: "mask-2_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_6_",
    className: "footer-logo-st1",
    points: "57.1,188.1 316.7,188.1 316.7,130.2 57.1,130.2  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15_1_",
    className: "footer-logo-st15",
    d: "M305.9,161.7c-0.5-5.5-2.3-8-4.8-8c-2.3,0-4.4,1.8-4.8,8H305.9z M296.3,166.9 c0.4,6.5,2.2,8.9,5.1,8.9c2.2,0,3.7-1.5,4.5-4.1l10.8,0.3c-0.8,2.3-2.2,4.6-4.8,6.6c-2.5,1.9-5.9,3.2-10.6,3.2 c-4.3,0-8.3-0.9-11.2-3.8c-2.8-2.7-4.4-6.9-4.4-13.4c0-5.3,1.4-10.1,4.6-13c2.5-2.4,6.1-3.8,11.1-3.8c4.3,0,7.9,1.1,10.7,4 c3.5,3.6,4.8,8.8,4.8,15.2H296.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1_1_",
    className: "footer-logo-st16",
    points: "88.3,189.7 94.2,186.1 94.2,135 88.3,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2_1_",
    className: "footer-logo-st16",
    points: "104.7,140 97.7,136.1 97.7,183.9 104.7,180  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(86.474944, 22.133929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 20.7,
    y: 119.8,
    width: 4.6,
    height: 36
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 20.7,
    y: 119.8,
    width: 4.6,
    height: 36,
    id: "mask-4_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st17"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_2_",
    className: "footer-logo-st1",
    points: "20.7,119.8 25.3,119.8 25.3,155.8 20.7,155.8  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3_1_",
    className: "footer-logo-st18",
    d: "M22.9,121.1l-2.2-1.3v36l2.2-1.3c1.5-0.9,2.4-2.5,2.4-4.3v-24.8 C25.3,123.6,24.4,122,22.9,121.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 60.4,
    y: 130.2,
    width: 25.6,
    height: 59.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60.4,
    y: 130.2,
    width: 25.6,
    height: 59.5,
    id: "mask-6_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "footer-logo-st19"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-5_6_",
    className: "footer-logo-st1",
    points: "60.4,130.2 86,130.2 86,189.7 60.4,189.7  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "footer-logo-st20",
    d: "M79.4,162.2c-1.2,0-2.2-1-2.2-2.3c0-1.3,1-2.3,2.2-2.3c1.2,0,2.2,1,2.2,2.3 C81.7,161.2,80.6,162.2,79.4,162.2 M83.6,130.8l-20.8,12.4c-1.5,0.9-2.4,2.5-2.4,4.3v24.8c0,1.8,0.9,3.4,2.4,4.3 L83.6,189c0.8,0.4,1.6,0.7,2.4,0.7v-59.5C85.2,130.2,84.3,130.4,83.6,130.8"
  }))))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.430e2acb.svg";
export { ForwardRef as ReactComponent };